module.exports = __webpack_public_path__ + "img/steps.a8f329a2.png";